import { DirectoryContactTypeaheadResponse } from "@/app/api/directory/contact/typeahead/route";
import { fetchLookupInfo } from "./fetch-lookup-info";
import { DirectoryCompanyTypeaheadResponse } from "@/app/api/directory/company/typeahead/route";
import {
  DirectoryLocationTypeaheadResponse,
  FormattedLocationTypeaheadItem,
} from "@/app/api/directory/location/typeahead/route";
import { GoogleDetailLookupResponse } from "@/external-services/types";
import { GetLookupInfoRequest } from "@costar-search-x/core";

const getCompanyTypeAheadSuggestions = async (term: string) => {
  const res = await fetch("/api/directory/company/typeahead", {
    method: "POST",
    body: JSON.stringify({ term }),
  });
  const result: DirectoryCompanyTypeaheadResponse = await res.json();

  return result?.data?.items?.map((i) => {
    return {
      key: i.key,
      displayText: i.displayText,
      label: i.label,
      secondary: i.secondary,
    };
  });
};

const getContactTypeAheadSuggestions = async (term: string) => {
  const res = await fetch("/api/directory/contact/typeahead", {
    method: "POST",
    body: JSON.stringify({ term }),
  });
  const result: DirectoryContactTypeaheadResponse = await res.json();

  return result?.data?.items?.map((i) => {
    return {
      key: i.key,
      displayText: i.displayText,
      label: i.label,
      secondary: i.secondary,
    };
  });
};

const getLocationTypeAheadSuggestions = async (term: string) => {
  const res = await fetch("/api/directory/location/typeahead", {
    method: "POST",
    body: JSON.stringify({ term }),
  });

  const result: DirectoryLocationTypeaheadResponse = await res.json();

  return result?.data?.items?.map((i: FormattedLocationTypeaheadItem) => {
    return {
      displayText: i.Term,
      label: i.Term,
      secondary: i.Description,
      value: i.value,
    };
  });
};

const getPlaceDetail = async (placeId: string) => {
  const res = await fetch("/api/directory/fetchPlaceDetail", {
    method: "POST",
    body: JSON.stringify({ placeId }),
  });
  const result: GoogleDetailLookupResponse = await res.json();

  return result?.items?.map((i) => {
    return {
      location: i.Location,
    };
  });
};

const lookupInfo = async (request: GetLookupInfoRequest) => {
  return fetchLookupInfo(request);
};

export {
  lookupInfo,
  getCompanyTypeAheadSuggestions,
  getContactTypeAheadSuggestions,
  getLocationTypeAheadSuggestions,
  getPlaceDetail,
};
